import { Row } from 'react-table';

export const getOriginalSelectedRows = (
  selectedFlatRows: Row<Record<string, unknown>>[]
): Record<string, unknown>[] =>
  // убираем неактивные строки
  selectedFlatRows.filter((row) => !row.isDisabled).map((row) => row.original);
